import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    account: null,
    data: { address: '', balance: '' }
};

const ethersSlice = createSlice({
    name: 'ethers',
    initialState,
    reducers: {
        setAccount: (state, action) => {
            state.account = action.payload;
        },
        setData: (state, action) => {
            state.data = action.payload;
        },
        resetEthersState: (state) => {
            state.account = null;
            state.data = { address: '', balance: '' };
        }
    }
});

export const { setAccount, setData, resetEthersState } = ethersSlice.actions;

export default ethersSlice.reducer;
